import { Auth } from 'aws-amplify';
import { KB_AUTOSUGGEST_GRAPHQL_CONFIG } from 'src/constants/AppConstants';

const getEndpoint = () => {
  const Stage = 'beta';
  const entry = KB_AUTOSUGGEST_GRAPHQL_CONFIG.find((c) => c.environment === Stage);
  if (!entry || !entry.grapQLEndPoint) {
    throw new Error(`No KB Autosuggest endpoint configured for stage '${Stage}'`);
  }
  return entry.grapQLEndPoint;
};

const getIdToken = async () => {
  const session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
};

/**
 * Query the KB Autosuggest AppSync API.
 * Returns an array of suggestion objects: { value, description, score, sourceUri }
 * formatted for the Cloudscape Autosuggest component.
 */
export const kbAutosuggest = async (prefix, maxResults, { signal } = {}) => {
  const endpoint = getEndpoint();
  const token = await getIdToken();

  const query = `query Autosuggest($input: AutosuggestInput!) {
    autosuggest(input: $input) {
      suggestions {
        title
        excerpt
        score
        sourceUri
      }
      resultCount
    }
  }`;

  const variables = {
    input: {
      prefix,
      ...(maxResults != null && { maxResults }),
    },
  };

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify({ query, variables }),
    ...(signal && { signal }),
  });

  if (!response.ok) {
    throw new Error(`kbAutosuggest request failed with status ${response.status}`);
  }

  const result = await response.json();

  if (result?.errors) {
    const err = new Error('kbAutosuggest returned GraphQL errors');
    err.graphqlErrors = result.errors;
    throw err;
  }

  const items = result?.data?.autosuggest?.suggestions || [];
  return items.map((item) => ({
    value: item.title || '',
    description: item.excerpt ? item.excerpt.substring(0, 100) : '',
    score: item.score,
    sourceUri: item.sourceUri,
  }));
};
